import React, { useContext, useEffect, useState } from "react";
import { useModal } from "../../../../hooks/ModalContext";
import { FaPause } from "react-icons/fa6";
import { DiscadorContext } from "../../../Discador";
import { DadosPausasType } from "../../../Discador/types";

export const SelectBreak = () => {
  const { getInfoPausa, setModal } = useModal()
  const [pausa, setPausa] = useState<number>()
  const { isLogged, listaPausas, onPause } = useContext(DiscadorContext)

  useEffect(() => {
    const infoPausa = (listaPausas && listaPausas?.length > 0 && listaPausas.find(item => pausa === item.id)) || {} as DadosPausasType
    if (infoPausa) {
      getInfoPausa(infoPausa)
    }
  }, [pausa])

  useEffect(() => {
    if (listaPausas && listaPausas?.length > 0) {
      setPausa(listaPausas[0].id)
    }
  }, [listaPausas])

  function openModal() {
    if (isLogged) {
      setModal('Pausas Hibrido', 'Pausas Hibrido', false, false)
      return
    }
    setModal('O operador precisa estar logado para usar essa função', 'Error', false, true)
  }

  return (
    <div className="flex items-center gap-2">
      <div className="flex items-center gap-2 text-sm">
        <strong className="text-primary font-normal">Pausas: </strong>
        <select
          className="w-full rounded-sm bg-gray-200 p-2 text-xs text-gray-600 outline-none"
          value={pausa}
          onChange={(e) => setPausa(Number(e.target.value))}
          disabled={onPause}
        >
          {
            listaPausas && listaPausas?.length > 0 && listaPausas.map(pausa => (
              <option key={pausa.id} value={pausa.id}>{pausa.name}</option>
            ))
          }
        </select>
      </div>
      <div>
        <button className="flex items-center gap-2 text-white bg-primary rounded-sm p-2  text-sm  disabled:bg-red-200 disabled:hover:bg-red-200" onClick={() => openModal()}>
          <FaPause className="fill-white" />
        </button>
      </div>
    </div>
  )
}